module.exports = __webpack_public_path__ + "GnuMICR.843195230478237efc06.eot";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/fonts/GnuMICR.eot
// module id = ../../../../../src/fonts/GnuMICR.eot
// module chunks = styles